import React from 'react';
import PropTypes from 'prop-types';

const className = Mobi2Go.helpers.classNames;

class VoucherApplied extends React.PureComponent {
    static propTypes = {
        voucher_has_error: PropTypes.bool.isRequired,
        voucher_applied: PropTypes.object,
        onRemove: PropTypes.func.isRequired,
    };

    render() {
        if (!this.props.voucher_applied) {
            return null;
        }

        return (
            <div
                className={className('m2g-order-voucher-discount', {
                    'm2g-order-voucher-discount--with-errors': this.props
                        .voucher_has_error,
                })}
            >
                <div
                    className={className(
                        'm2g-order-voucher-discount-icon',
                        'm2g-icon',
                        {
                            'm2g-icon--gift': !this.props.voucher_has_error,
                            'm2g-icon--alert': this.props.voucher_has_error,
                        }
                    )}
                />
                <div className="m2g-order-voucher-discount-name">
                    {this.props.voucher_applied.name}
                </div>
                <div
                    className="m2g-order-voucher-discount-remove m2g-icon m2g-icon--cross"
                    onClick={this.props.onRemove}
                />
            </div>
        );
    }
}

export default VoucherApplied;
